// @ts-strict-ignore
import Select from '@carvana/ds-select';
import { Option } from '@carvana/ds-popup';
import { useState } from 'react';
import TextInput from '@carvana/ds-text-input';
import { useTestFunc } from '@carvana/test-attributes';

import { PlateState, PlateTextWrapper, Wrapper } from './PlateEntry.styles';
import usaStates from 'shared/usaStates';

type PlateEntryProps = {
  plate: string;
  plateError: string;
  plateState: string;
  plateStateError: string;
  touched: boolean;
  updatePlate: React.ChangeEventHandler<HTMLInputElement>;
  updatePlateState: ({ value }: { value: string }) => void;
};

const PlateEntry = ({
  plateError,
  plateStateError = '',
  plate,
  plateState,
  updatePlate,
  updatePlateState,
  touched
}: PlateEntryProps) => {
  const [isPlatePristine, setIsPlatePristine] = useState(true);
  const [isStatePristine, setIsStatePristine] = useState(true);
  const getTestAttributes = useTestFunc();

  const setPlateNotPristine = () => setIsPlatePristine(false);
  const setStateNotPristine = () => setIsStatePristine(false);
  const plateTextTouched = touched || !isPlatePristine;
  const plateStateTouched = touched || !isStatePristine;

  const handleStateChange = (_: unknown, __: unknown, value: string) => {
    updatePlateState({ value });
  };

  const hasPlateError = plateTextTouched && !!plateError;
  const plateErrorMessage = plateError || '';

  return (
    <PlateState>
      <PlateTextWrapper>
        <TextInput
          {...getTestAttributes('LicensePlateInput')}
          hasError={hasPlateError && plateTextTouched}
          label="License Plate"
          maxLength={8}
          onChange={updatePlate}
          onBlur={setPlateNotPristine}
          value={plate}
          id="license_plate"
          error={!!hasPlateError && plateErrorMessage}
        />
      </PlateTextWrapper>
      <Wrapper>
        <Select
          label="State"
          value={plateState}
          onBlur={setStateNotPristine}
          onChange={handleStateChange}
          hasError={plateStateTouched && !!plateStateError}
          error={plateStateTouched && plateStateError ? plateStateError : ''}
        >
          {usaStates.map(state => (
            <Option key={state} value={state}>
              {state}
            </Option>
          ))}
        </Select>
      </Wrapper>
    </PlateState>
  );
};

export default PlateEntry;
